// EGDE-360: FAQ answers may be a plain string (legacy Textarea) or a Rich Text
// Editor value (`{ markup }`) once the CMS field is switched to RTE. These
// helpers let the FAQ blocks render either shape and keep text-search working.

/** Returns the RTE markup when the answer is a Rich Text value, else null. */
export function getFaqAnswerMarkup(answer: unknown): string | null {
  if (answer && typeof answer === "object" && "markup" in answer) {
    const markup = (answer as { markup?: string | null }).markup
    return markup ? markup : null
  }
  return null
}

/** Plain-text form of the answer for search matching (strips any HTML). */
export function getFaqAnswerText(answer: unknown): string {
  if (typeof answer === "string") return answer
  const markup = getFaqAnswerMarkup(answer)
  return markup ? markup.replace(/<[^>]*>/g, " ") : ""
}
